// VideoMessage.js
import React from 'react'
import Mixpanel from '../../../utils/mixpanel'
import { ANALYTIC_EVENTS } from '../../../utils/constants'
import './VideoMessage.css'
import playButton from '../../../assets/images/play-icon.png'
import VideoThumbnail from 'react-video-thumbnail'
import { isNullOrMissing, moment_type_mapping } from '../../../helpers'

const VideoMessage = ({
  content,
  openModal,
  authorType,
  analyticData,
  message,
  momentType
}) => {
  const [thumbnail, setThumbnail] = React.useState('')
  const cta =
    authorType === 'ME' ? content?.cta_teacher?.[0] : content?.cta?.[0]

  const ctaClickHandler = (e) => {
    Mixpanel.trackEvent({
      event: ANALYTIC_EVENTS.MESSAGE_CTA_CLICKED,
      data: {
        body: content.body,
        redirection: cta?.value,
        ...analyticData
      }
    })
    e.preventDefault()
    openModal(cta?.value)
  }
  const momentTypeMapping = moment_type_mapping[momentType]
  const srcUrl =
    authorType === 'ME'
      ? momentTypeMapping?.meSrcUrl
      : momentTypeMapping?.srcUrl

  return (
    <>
      <div className="video-moments-container">
        {!isNullOrMissing(content.media.value) && (
          <div className="video-container">
            {/* <img src={playButton} className='video-play-button' />
          <div className='video-thumbnail-container'>
            <VideoThumbnail
              videoUrl={content.media.value}
              thumbnailHandler={(thumbnail) => setThumbnail(thumbnail)}
              // height={80}
              // width={80}
              renderThumbnail={false}
              snapshotAtTime={1}
            />
          </div>
          <img
            src={thumbnail}
            alt="media"
            className="moments-media-preview"
            onClick={(e) => {
              e.preventDefault()
              // openModal(content.media.value)
            }}
          /> */}
            <video
              src={content.media.value + '#t=0.5'}
              className="moments-media-preview"
              onClick={(e) => {
                e.preventDefault()
                // openModal(content.media.value)
              }}
            />
          </div>
        )}
        <div>
          <div className="moment-type-container">
            {srcUrl && isNullOrMissing(content.media.value) && (
              <img src={srcUrl} className="moment-type-icon" />
            )}
            <div
              style={authorType === 'ME' ? { color: 'white' } : null}
              className="moment-type-label">
              {momentTypeMapping?.label}
            </div>
          </div>
          <p className="cta-body">
            {isNullOrMissing(content?.body)
              ? isNullOrMissing(content.media.value)
                ? ''
                : "Hey, I've shared a new moment!"
              : content.body}
          </p>
        </div>
      </div>

      {cta && cta?.label && cta?.value && (
        <div
          className="cta-container"
          onClick={(e) => {
            e.preventDefault()
            openModal(content.media.value)
          }}>
          <a
            href="#"
            className={`cta-button ${authorType === 'ME' ? 'me' : 'not-me'}`}
            onClick={ctaClickHandler}>
            {cta?.label} →
          </a>
        </div>
      )}
    </>
  )
}

export default VideoMessage
